import { TransactionType } from "@/core/services/api/enums/TransactionType";

export interface TransactionFilterParams {
  _mode?: FilterMode;
  company_id?: number | null;
  bank_account_id: number | null;
  transaction_id: null | number[];
  page: number;
  per_page: number;
  search: string | null;
  type_id: TransactionType[] | string[];
  created_at_from: string | null;
  created_at_to: string | null;
  tc?: string[];
}

export interface AffiliateTransactionFilterParams {
  _mode?: FilterMode;
  company_id?: number | null;
  bank_account_id: null | number[];
  transaction_id: null | number[];
  page: number;
  per_page: number;
  search: string | null;
  type_id: TransactionType[] | string[];
  created_at_from: string | null;
  created_at_to: string | null;
  tc?: string[];
}

export interface WhiteLabelTransactionFilterParams {
  _mode?: FilterMode;
  company_id?: number | null;
  bank_account_id: null | number[];
  transaction_id: null | number[];
  page: number;
  per_page: number;
  search: string | null;
  type_id: TransactionType[] | string[];
  created_at_from: string | null;
  created_at_to: string | null;
  tc?: string[];
}

export enum FilterMode {
  APPROVED_TRANSACTIONS = "approved_transactions",
  PENDING_TRANSACTIONS = "pending_transactions",
  ADMIN_ACTION_REQUIRE_TRANSACTIONS = "admin_action_require_transactions",
}
